import { render, staticRenderFns } from "./Lowerthird.vue?vue&type=template&id=2981d2b0&scoped=true&lang=html&"
import script from "./Lowerthird.vue?vue&type=script&lang=js&"
export * from "./Lowerthird.vue?vue&type=script&lang=js&"
import style0 from "./Lowerthird.vue?vue&type=style&index=0&id=2981d2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981d2b0",
  null
  
)

export default component.exports